module.exports = __webpack_public_path__ + "img/p4.d3ef0b28.png";